if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        // BUG (post-LIVE 2026-06-02): browser extensions (Honey / Capital
        // One Shopping) instantiate <product-form> elements with no inner
        // <form>, so querySelector("form") is null and the next line threw
        // "Cannot read properties of null" 300+ times. Bail out cleanly.
        if (!this.form) return;
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        
        const showErrorHidden = document.querySelectorAll(".hidden__err");

        showErrorHidden.forEach((f) => (f.style.display = "none"));

        if (submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();
        this.cartNotification.setActiveElement(document.activeElement);

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.cartNotification
            .getSectionsToRender()
            .map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        let quantity = parseFloat(formData.get("quantity"))
        const productId = parseFloat(formData.get("product-id"))

        // BUG minmax PDP (2026-06-06): enforce the per-product MINIMUM on the
        // Add path (the maximum is enforced below via .hidden__temp--<id>,
        // which main-product.liquid now fills from custom.max_qty). The PDP
        // qty input ships value=min, but a typed/stepped value can still be
        // lower. Boss decision: clamp UP to the minimum and tell the user via
        // the shared i18n bridge (window.aefT, ae-delivery-widget.js) so the
        // message follows the current ae_lang. Card forms have no data-min-qty
        // on the input (the card stepper enforces there) -> NaN -> skipped.
        const qtyInputEl = this.form.id
          ? document.querySelector(`input[name="quantity"][form="${this.form.id}"]`)
          : null;
        const minQtyAttr = qtyInputEl ? parseInt(qtyInputEl.getAttribute("data-min-qty"), 10) : NaN;
        if (minQtyAttr > 1 && quantity > 0 && quantity < minQtyAttr) {
          quantity = minQtyAttr;
          formData.set("quantity", String(minQtyAttr));
          qtyInputEl.value = String(minQtyAttr);
          const showMinMsg = this.querySelector(`.show__err--${productId}`);
          if (showMinMsg) {
            showMinMsg.style.display = "block";
            // 18/8/2026 — cùng một cửa với cart.js + mini-cart-popup.js
            // (window.aefTienToiThieu, layout/theme.liquid) để câu này nói cả
            // thành tiền. Đơn giá lấy từ data-unit-price của chính qtyInputEl —
            // phần tử vừa cung cấp data-min-qty ở trên, và là thứ
            // aef-moq-relax.js cập nhật lại mỗi lần khách đổi biến thể.
            showMinMsg.textContent = window.aefTienToiThieu
              ? window.aefTienToiThieu(minQtyAttr, window.aefGiaDonVi(qtyInputEl))
              : (window.aefT ? window.aefT("card.min_hint") : "Min order:") + " " + minQtyAttr;
          }
        }

        const cartContents = await fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(data => data);

        let isCheckMaxQuantity = false
        const maxQuantity = document.querySelector(
          `.hidden__temp--${productId}`
        );

        const currentSize = formData.get('Size')
        
        const maxQuantityFormat = parseFloat(maxQuantity.textContent);
        
        for(let i = 0; i < cartContents.items?.length; i++) {
          
          let isCheckCart = false;
          if(currentSize) {
            isCheckCart = cartContents.items[i].product_id  === productId && (currentSize === cartContents.items[i].options_with_values[0]?.value || currentSize === cartContents.items[i].options_with_values[0])
          } else {
            isCheckCart = cartContents.items[i].product_id  === productId
          }
          
          if(isCheckCart) {
            const totalQuantityCart = cartContents.items[i].quantity + quantity
            
            const currentQuantityCart = cartContents.items[i].quantity
            if(totalQuantityCart > maxQuantityFormat || currentQuantityCart > maxQuantityFormat) {
              isCheckMaxQuantity = true
            }
            break;
          }
        }
       
        if (isCheckMaxQuantity || (quantity > maxQuantityFormat)) {

          const showError = this.querySelector(`.show__err--${productId}`);
          showError.style.display = "block";
          // i18n via the shared bridge (BUG minmax 2026-06-06) — reuses the
          // stepper key so card/PDP/cart wording stays consistent.
          showError.innerHTML =
            (window.aefT ? window.aefT("card.max_tooltip") : "Max reached") +
            ` (${maxQuantityFormat})`;
  
          submitButton.classList.remove("loading");
          submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading-overlay__spinner").classList.add(
            "hidden"
          );
        } else {
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.querySelector(".wbquicksuccess").classList.add("hidden"); // Webibazaar Quickview Message
                this.handleErrorMessage(response.description);
                return;
              }

              quantity = response.quantity
              
              if (quantity > maxQuantityFormat) {
                const showError = this.querySelector(
                  `.show__err--${productId}`
                );
                showError.style.display = "block";
                showError.innerHTML =
                  (window.aefT ? window.aefT("card.max_tooltip") : "Max reached") +
                  ` (${maxQuantityFormat})`;

                submitButton.classList.remove("loading");
                submitButton.removeAttribute("aria-disabled");
                this.querySelector(".loading-overlay__spinner").classList.add(
                  "hidden"
                );
              } else {

              this.cartNotification.renderContents(response);
              this.querySelector(".wbquicksuccess").classList.remove("hidden"); // Webibazaar Quickview Message
              }
            })
            .catch((e) => {
              console.error(e);
              /* 2026-08-17 — TRƯỚC ĐÂY CHỈ console.error RỒI IM.
                 Nhánh này chạy khi fetch hỏng ở tầng mạng (rớt sóng, DNS, CORS,
                 JSON vỡ) — khác nhánh `response.status` phía trên vốn đã báo khi
                 MÁY CHỦ từ chối. Nên trên PDP, mất mạng giữa chừng = nút quay
                 xong rồi trở lại bình thường, không món nào vào giỏ, không một
                 chữ nào cho khách. Đúng họ lỗi "nút + nuốt lỗi máy chủ" đã vá ở
                 vòng 10 cho thẻ sản phẩm; đường PDP khi đó không được sờ tới.
                 Dùng lại đúng mặt báo lỗi chung để chữ và chỗ hiện thống nhất. */
              if (typeof window.aefShowAddError === "function") {
                window.aefShowAddError(0);
              } else {
                this.handleErrorMessage(
                  (window.aefT && window.aefT("drawer.toast_err_generic")) ||
                    "Couldn't add to cart — please try again"
                );
              }
            })
            .finally(() => {
               
                submitButton.classList.remove("loading");
                submitButton.removeAttribute("aria-disabled");
                this.querySelector(".loading-overlay__spinner").classList.add(
                  "hidden"
                );
              
            });
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
